export default __webpack_public_path__ + "static/reports-presentation-4c278111cb5ab6ab5d94c6d6143bfcc0.png";